import React, { useEffect, useState } from 'react'
import { BigEmailIcon, BigWhatsAppIcon } from 'assets/icons'
import { changePasswordToken } from 'api/change-password'
import { useParams } from 'react-router-dom'
import PageWrapper from './PageWrapper'
import RecoveryPasswordLink from './RecoveryPasswordLink'

const RecoveryPasswordMethod = () => {
  const [counter, setCounter] = useState(59)
  const [attempts, setAttempts] = useState(0)
  const [, setDisabled] = useState(false)
  const [message, setMessage] = useState('')

  const { method } = useParams()

  const recovPasswordMethod = {
    // whatsAppMethod: 'whatsapp',
    emailMethod: 'email'
  }

  useEffect(() => {
    const timer =
      counter > 0 && setInterval(() => setCounter(counter - 1), 1000)
    return () => clearInterval(timer)
  }, [counter])

  const resendCode = (type) => {
    changePasswordToken({ contact_type: type }).then((data) => {
      if (data?.success) {
        setMessage(data.data?.message)
      } else {
        setMessage(data.error?.message)
      }
    })
  }

  return (
    <PageWrapper title='Cambiar contraseña' noTabBar>
      <section className='flex min-h-max justify-center items-center mt-24 md:items-start'>
        {/* {method === recovPasswordMethod.whatsAppMethod &&
          <RecoveryPasswordLink
            icon={<BigWhatsAppIcon />}
            title='¡WhatsApp Enviado! '
            subtitle='Revisa tus mensajes'
            content='Hemos enviado un link para ingresar y completar el proceso de solicitud de préstamo al celular terminado en '
            tag='Tenés 3 horas para usar el link'
            counter={counter}
            disabled={attempts >= 3}
            onClick={() => {
              setCounter(59)
              setAttempts(attempts + 1);
              resendCode('SMS')
            }} />
        } */}
        {method === recovPasswordMethod.emailMethod && (
          <RecoveryPasswordLink
            icon={<BigEmailIcon />}
            title='¡Email enviado!'
            subtitle='Revisá tus mensajes'
            content='Hemos enviado un link para ingresar y completar el proceso'
            message={message}
            tag='Tenés 3 horas para usar el link'
            counter={counter}
            // disabled={attempts >= 3}
            onClick={() => {
              setCounter(59)
              // setAttempts(attempts + 1);
              resendCode('EMAIL')
            }}
          />
        )}
      </section>
    </PageWrapper>
  )
}

export default RecoveryPasswordMethod
